
import * as Enumerable from 'linq';

import { FiltersNumberMethod } from '../../utilities/filters.number.utility';
import { FiltersRelativeDateMethod } from '../../utilities/filters.relative.date.utility';
import { Entity } from '../entity';
import { QuoteSimpleStatus } from './quote.pro';

export interface QuoteProViewLookups {

    account?: Entity[];
    owner?: Entity[];
    company?: Entity[];
    status?: QuoteSimpleStatus[];

    jobType?: Entity[];
}

export interface QuoteProViewFilters extends QuoteProViewLookups {
    _id?: string;

    search?: string;
    prepaymentOnly?: boolean;
    status?: QuoteSimpleStatus[];

    totalSellEx?: FiltersNumberMethod;
    date?: FiltersRelativeDateMethod;
    expiryDate?: FiltersRelativeDateMethod;
    createdAt?: FiltersRelativeDateMethod;

}

export function effectiveQuoteProViewFilters(view: QuoteProViewFilters, refinements: QuoteProViewFilters) {

    const effective: { [k in keyof QuoteProViewFilters] } = {} as QuoteProViewFilters;
    const keys = Object.keys(new QuoteProViewFiltersClass())

    Enumerable.from(keys)
        .forEach(key => {

            const refinement = refinements[key];
            const viewValue = view[key];

            if (Array.isArray(refinement) || Array.isArray(viewValue)) {
                effective[key] = refinement?.length
                    ? refinement
                    : viewValue;
            } else {
                effective[key] = refinement
                    ? refinement
                    : view[key];
            }

            if (effective[key] == null ||
                (typeof effective[key] !== 'boolean' && Object.keys(effective[key])?.length == 0)
            ) {
                delete effective[key];
            }
        });

    return effective;

}

export function isQuoteProViewFiltersRefined(refinements: QuoteProViewFilters): boolean {

    if (!refinements) return false;
    if (refinements.search && (refinements.search !== null || refinements.search === '')) return true;

    if (refinements?.account?.length) return true;
    if (refinements?.owner?.length) return true;
    if (refinements?.company?.length) return true;
    if (refinements?.jobType?.length) return true;

    if (refinements.date) return true;
    if (refinements.expiryDate) return true;
    if (refinements.createdAt) return true;
    if (refinements.status?.length) return true;
    if (refinements.prepaymentOnly) return true;
    if (refinements.totalSellEx) return true;

    return false;
}


class QuoteProViewFiltersClass implements Required<QuoteProViewFilters> {
    _id = null

    // Multi - Need to check data inside
    search: string = null;
    prepaymentOnly: boolean = false;

    account: Entity[] = [];
    status: QuoteSimpleStatus[] = [];
    owner: Entity[] = [];
    company: Entity[] = [];

    jobType: Entity[] = [];

    totalSellEx: FiltersNumberMethod = null;
    date: FiltersRelativeDateMethod = null;
    expiryDate: FiltersRelativeDateMethod = null;
    createdAt: FiltersRelativeDateMethod = null;
}
